<template>
    <table
        class="table table-striped"
        style="background:white;margin-top:20px;"
    >
        <thead>
        <tr>
            <th></th>
            <th class="hidden-sm">City</th>
            <th class="hidden-sm">State</th>
            <th
            :class="{'hidden-sm':!field.showInTableOnSmall}"
            v-for="field in tableFields"
            :key="field.id+'_head'"
            >
            <a style="cursor:pointer" @click="sortBy(field)">{{field.name}}</a>
            </th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(listing,i) in listings">
            <tr :key="listing.id + '_listing' + i" @click="showInfo(listing)" :class="{
            'small':listing.priceName == 'Small',
            'medium':listing.priceName == 'Medium',
            'large':listing.priceName == 'Large',
            'pointer':true
            }">
            <td>
            <a :href="`https://${listing.website}`" target="_blank">
                <img v-if="listing.photo" :src="`https://api.everythingcheeranddance.com/public/photo?key=${listing.photo}`" width="100px" height="100px"
                style="border-radius:10px;object-fit:cover;" />
            </a>
            </td>
            <td  class="hidden-sm">
                <span>
                {{listing.city}}
                </span>
            </td>
            <td class="hidden-sm">
                <span>
                {{listing.state}}
                </span>
            </td>
            <td
                :class="{'hidden-sm':!findShowInTableFromField(listing,field.name)}"
                v-for="field in tableFields"
                :key="field.id"
            >{{utils.findFieldValue(listing,field.name)}}</td>
            </tr>
        </template>
        </tbody>
    </table>
</template>

<script>
import Utils from "@/Utils/Utils";
import ListingModal from "./ListingModal.vue";

export default {
  name: "FeedTable",
  components: {
  },
    data() {
    return {
      utils: Utils
    };
  },
  props: {
      listings: {
          default:[]
      },
      fields: {
          default: []
      },
      showSearch: {
          default: false
      }
  },
  computed: {
    tableFields() {
      let fields = this.fields.filter(it => {
        return it.showInTable == 1;
      });
      if(!fields) {
        return [];
      }

      return fields;
    },
    numColumns() {
      return this.tableFields.length;
    },
    searchableFields() {
      return this.fields.filter(it => {
        return it.searchable == 1;
      });
    }
  },
  methods: {
    findShowInTableFromField(listing, fieldName) {
      var value = "";
      listing.fields.forEach(field => {
        if (field.name == fieldName) {
          value = field.showInTableOnSmall;
        }
      });
      return value == 1 ? true : false;
    },
    sortBy(field) {
      this.$emit("sortBy",field)
    },
    getImgUrl(pic) {
      return require("@/assets/" + pic);
    },
    favorite(listing) {
      this.$emit("favorite",listing)
    },
    unfavorite(listing) {
      this.$emit("unfavorite",listing)
    },
    showInfo(listing) {
      //   console.log("show info")
      //   console.log(listing)
      //   this.$emit('showInfo',listing)
      // this.$forceUpdate();

      const options = {listing:listing,name:'ListingModal',};
      const style = { width: "85%", height: "auto", scrollable:true };
      const events = {
        opened: () => console.log("Opened"),
        closed: () => console.log("Closed")
      };

      this.$modal.show(ListingModal, options, style, events);
    },
    toggleShowSearch() {
        console.log("show search")
        this.$emit('showSearch')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 768px) {
  .hidden-sm {
    display: none;
  }
}

.white {
  color: white;
}

.search {
  background: #f2f2f2;
  border-radius: 10px;
  margin: 0px;
  padding: 20px;
  margin-bottom: 20px;
}

.small{
  font-size:90%;
}

.medium{
  font-size:130%;
}

.large{
  font-size:170%;
}
</style>



// WEBPACK FOOTER //
// src/components/FeedTable.vue